import { DeleteOutlined } from '@ant-design/icons';
import { Col, Image, Row, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import withStyles from 'react-jss';

import { useDispatch, useSelector } from 'react-redux';
import { setSampleFiles } from '../Actions';
import { apiURL } from '../config';
import styles from '../styles';

const ShowFiles = props => {
  const { productIndex, classes, watch, setValue, unregister } = props;

  const dispatch = useDispatch();

  const onRemove = image => {
    dispatch(setSampleFiles(productIndex, image, true));
  };

  const productExistFiles = watch(`products[${productIndex}].files`);

  const onExistRemove = index => {
    const newImages = [...productExistFiles];

    newImages.splice(index, 1);

    setValue(`products[${productIndex}].files`, newImages);
    unregister(`products[${productIndex}].files[${newImages.length}]`);
  };

  const files = useSelector(state => state.sampleFiles);

  const renderImage = (image, index) => {
    return (
      <Fragment key={index}>
        <Col xs={24} sm={7} md={6} lg={3} xl={2}>
          <Tooltip
            placement="topLeft"
            title={<DeleteOutlined onClick={() => onRemove(image)} />}
          >
            <Image
              src={URL.createObjectURL(image)}
              className={classes.sampleImage}
            />
          </Tooltip>
        </Col>
        <Col xs={0} sm={1} />
      </Fragment>
    );
  };

  const renderExistImage = (image, index) => {
    return (
      <Fragment key={index}>
        <Col xs={24} sm={7} md={6} lg={3} xl={2}>
          <Tooltip
            placement="topLeft"
            title={<DeleteOutlined onClick={() => onExistRemove(index)} />}
          >
            <Image
              src={`${apiURL}/${image.key}`}
              className={classes.sampleImage}
            />
          </Tooltip>
        </Col>
        <Col xs={0} sm={1} />
      </Fragment>
    );
  };

  return (
    <Row>
      <Image.PreviewGroup>
        {productExistFiles?.length
          ? productExistFiles.map(renderExistImage)
          : null}
        {files.products[productIndex]?.files?.length
          ? (files.products[productIndex]?.files || []).map(renderImage)
          : null}
      </Image.PreviewGroup>
    </Row>
  );
};

ShowFiles.propTypes = {
  productIndex: PropTypes.number.isRequired,
  classes: PropTypes.object.isRequired,
  watch: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  unregister: PropTypes.func.isRequired,
};

export default withStyles(styles)(ShowFiles);
